import { cloneDeep, merge } from "lodash-es";
import gql from "fraql";
export default function (horses, registrationHorses) {
    return registrationHorses.map((regHorse) => {
        var _a, _b, _c, _d, _e;
        if (!regHorse.horseId) {
            return {
                id: regHorse.id,
                isNonReference: true,
                horseName: regHorse.horseName,
                isHorseSlot: regHorse.isHorseSlot
            };
        }
        const horse = horses.find(h => h.id == regHorse.horseId);
        return merge(cloneDeep(horse), {
            name: (_a = regHorse.horseName) !== null && _a !== void 0 ? _a : horse.name,
            ponyType: (_b = regHorse.horsePonyType) !== null && _b !== void 0 ? _b : horse.ponyType,
            horseType: (_c = regHorse.horseType) !== null && _c !== void 0 ? _c : horse.horseType,
            registrationHorseId: regHorse.id,
            isHorseSlot: (_d = regHorse.isHorseSlot) !== null && _d !== void 0 ? _d : horse.isHorseSlot,
            beddingType: (_e = regHorse.beddingType) !== null && _e !== void 0 ? _e : null
        });
    });
}
export const RegistrationHorseFragment = gql `
  fragment _ on RegistrationHorse {
    horseId
    horseName
    horsePonyType
    horseType
    beddingType
    isHorseSlot
  }
`;
